import React, {useState} from "react";
import { makeStyles } from '@material-ui/core/styles';
import Popover from '@material-ui/core/Popover';
import FlagOutlinedIcon from '@material-ui/icons/FlagOutlined';
import DoneOutlineIcon from '@material-ui/icons/DoneOutline';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import Typography from '@material-ui/core/Typography';
import $ from 'jquery';


import FormLabel from '@material-ui/core/FormLabel';


import Button from '@material-ui/core/Button';


const useStyles = makeStyles((theme) => ({
    upbtnon:{
        textTransform: 'initial',
        backgroundColor: 'rgb(3 112 237)',
        border: 'solid 1px rgb(3 112 237)',
        color: 'white',
        '&:hover':{
            backgroundColor: 'rgb(3 112 237)'
        },
        marginBottom: '3px'
    },
    upbtndown:{
        textTransform: 'initial',
        border: 'solid 1px rgb(3 112 237)',
        color: 'rgb(3 112 237)',
        marginBottom: '3px'
    },
    downbtnon:{
        textTransform: 'initial',
        backgroundColor: 'rgb(220, 50, 32)',
        border: 'solid 1px rgb(220, 50, 32)',
        color: 'white',
        '&:hover':{
            backgroundColor: 'rgb(220, 50, 32)'
        },
        marginBottom: '3px'

    }, 
    downbtndown:{
        textTransform: 'initial',
        color: 'rgb(220, 50, 32)',
        border: 'solid 1px rgb(220, 50, 32)',
        marginBottom: '3px'

    },
    btnholder:{
        display: 'inline'
    },
    popoverelem:{
        padding: '15px',
    },
    radio:{
        marginBottom: 0,
        paddingBottom: 0
    },
    label: {
        fontSize: '14px'
    }
}));

export default function HashTag(props){
    const username = localStorage.getItem('username');

    const hashtag=props.hashtag;
    const classes=useStyles();

    const [anchorEl, setAnchorEl] = useState(null);
    const [flagStep, setFlagStep] = useState(0);
    const [reason, setReason] = useState('');

    const handleRightClick = (event) => {
        event.preventDefault();
        setAnchorEl(event.currentTarget);
      };
    
    const handleClose = () => {
        setAnchorEl(null);
        setTimeout(function(){
            setFlagStep(0);
            setReason('');
        }, 300)
      };
    const open = Boolean(anchorEl);
    const id = open ? 'flagbtn' : undefined;

    const handleRadioChange = (event) => {
        setReason(event.target.value);
      };

    const handleSubmit = (event) => {
        event.preventDefault();
        
        $.ajax({
            url:'/binarytext/add-flag/',
            method: 'POST',
            data: {'hashtag_id': hashtag.id,'username': username, 'reason':reason},
            success: function(res){
                setFlagStep(2);
                setTimeout(
                    function(){
                        handleClose();
                    }, 1000
                )
            },
            error: function(err){
                console.log('error!')
            },
          });
      };

    const handleChangeVote = () => {
        props.changeHashtagVote(username, props.commentId, props.direction, hashtag.id, hashtag.voted);
    }

    return(
        <div className={classes.btnholder}>
            <Button className={(props.direction==='up'? (hashtag.voted? classes.upbtnon : classes.upbtndown): (hashtag.voted? classes.downbtnon : classes.downbtndown))} 
            size='small' style={{textTransform: 'initial', paddingTop: 2, paddingBottom: 2, minWidth: 0, marginLeft: 5}}
            onClick={()=>handleChangeVote()} onContextMenu={handleRightClick}>
                {hashtag.label} {hashtag.votes} 
         </Button>
         <Popover 
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
                vertical: 'center',
                horizontal: 'center',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
            }}
            
            >
            {flagStep===0?
            <Button startIcon={<FlagOutlinedIcon/>} onClick={()=>setFlagStep(1)} className={classes.popoverelem}>
                Flag this button
            </Button>: null
            }
            {flagStep===1?
            <form onSubmit={handleSubmit} className={classes.popoverelem}>
                <FormControl component="fieldset">
                <Typography style={{fontSize: '15px'}}>
                I'm flagging this comment as ... 
            </Typography>
                <RadioGroup size='small' aria-label="quiz" name="quiz" value={reason} onChange={handleRadioChange}>
                    <FormControlLabel classes={{label: classes.label}} value="insulting" control={<Radio size='small'/>} label="Insulting or Offensive" />
                    <FormControlLabel classes={{label: classes.label}} value="irrelevant" control={<Radio  size='small' />} label="Irrelevant or Gaming" />
                    <FormControlLabel classes={{label: classes.label}} value="other" control={<Radio  size='small' />} label="Other" />
                </RadioGroup>
                <Button type="submit" variant="outlined" color="primary">
                    SEND
                </Button>
                </FormControl>
            </form>
            : null
            }
            {flagStep===2?
            <Button startIcon={<DoneOutlineIcon/>} onClick={()=>setFlagStep(1)} className={classes.popoverelem}>
             Your flag has been recorded.        
            </Button>
            : null
            }
        </Popover>
      </div>
    )
}
